import React, { useEffect, useState, useCallback } from "react";
import { FormattedDate, FormattedMessage, IntlFormatters, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import { languages } from "../../../../common/parameters";

import { IStateTree } from "../../../store/interfaces";
import { profilePictureHost } from "../../../paths";
import Icon from "../../../icon";
import PlanCard from "../../../components/PlanCard";

import { Holder, Hero, UserImage, Decoration, Bulb, Rod } from "./styles";
import messages from "./messages";

const getBodyElement = () => {
    const el = document.scrollingElement || document.documentElement;
    return el;
};

const TeacherPage = () => {
    const [max, setMax] = useState(12);
    const handleScroll = useCallback(() => {
        const scroll = document.body.getBoundingClientRect().height - window.innerHeight - getBodyElement().scrollTop;
        if (scroll < 120) {
            setMax(lastMax => lastMax + 12);
        }
    }, [setMax]);
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);
    
    const {
        username,
        work_since,
        created,
        language,
        plans,
        displayName,
        profilePicture,
    } = useSelector(({ teacher }: IStateTree) => teacher)!;
    const { formatMessage } = useIntl();
    return (
        <div>
            <Hero>
                <div>
                    <UserImage>
                        {profilePicture ? (
                            <img src={profilePictureHost + profilePicture + ".jpg"} alt="profile" />
                        ) : (
                            <Icon i="user" />
                        )}
                    </UserImage>
                </div>
                <Decoration>
                    <Bulb></Bulb>
                    <Rod></Rod>
                    <Bulb></Bulb>
                </Decoration>
                <div>
                    <h2>{username}</h2>
                    {displayName && <h3>{displayName}</h3>}
                    {work_since && (
                        <div>
                            <FormattedMessage {...messages.teaching} values={{ year: getYear(work_since) }} />
                        </div>
                    )}
                    <div>
                        <FormattedMessage {...messages.joining} /> {new Date(created).getFullYear()}.{" "}
                        <FormattedDate value={new Date(created)} month="long" /> {new Date(created).getDate()}.
                    </div>
                    <div>
                        <FormattedMessage {...messages.language} />: {getLanguage(language, formatMessage)}
                    </div>
                </div>
            </Hero>
            <div>
                <h2>
                    <FormattedMessage {...messages.listedPlans} />
                </h2>
                <Holder>
                    {plans.map((plan: any, key: number) => {
                        if (key >= max) return null;
                        return <PlanCard browse plan={plan} key={plan._id} />;
                    })}
                </Holder>
            </div>
        </div>
    );
}

export default TeacherPage;

const getLanguage = (lang: string, fm: IntlFormatters["formatMessage"]) => {
    let label;
    languages(fm).forEach(language => {
        if (language.value === lang) label = language.label;
    });
    return label;
};

const getYear = (work_since: number) => {
    const thisYear = new Date().getFullYear();
    return thisYear - work_since;
};
